import React,{useState,useEffect} from 'react'
import { useHistory } from 'react-router-dom'
import mypic from './compo images/mypic.jpg'
import git from './compo images/git.png'
import linkedin from './compo images/linkedin.png'
import telegram from './compo images/telegram.png'
import send from './compo images/send.png'

function Home() {
    const history=useHistory();
    const[cursorColor,upcursorColor]=useState("black");
    useEffect(()=>{
        //navbar code
        document.querySelector('#nmode_').addEventListener('click', () => {//if button clicked of navbar
            if (document.querySelector('#night_mode').checked === false) {
                upcursorColor("black");
            }
            else {
                upcursorColor("white");
            }
        })
        //home body code
        if (document.querySelector('body').classList.contains('nightbackground') === false) {//on arriving of page
            upcursorColor("black");
        }
        else {
            upcursorColor("white");
        }
    },[cursorColor])
    
    return (
        <>
            <div className="row homebody">
                <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                    <div className="socials">
                        <div className="s1">
                            <a href="https://github.com/AbuFaishal" target="_blank"><img src={git} alt="" title="github" /></a>
                        </div>
                        <div className="s2">
                        <a href="https://www.linkedin.com/in/abu-faishal-3443951a5/" target="_blank"><img src={linkedin} alt="" title="linkedin" /></a>
                        </div>
                        <div className="s3">
                        <a href="#"><img src={telegram} alt="" title="telegram" /></a>
                        </div>
                    </div>
                </div>
                <div className="d-block d-md-none col p-2">
                    <div className="imgbox">
                        <img src={mypic} alt="mypic" title="mypic"/>
                    </div>
                </div>
                <div className="col-lg-4 col-md-5 col-sm-10 col-10 p-3">
                    <p className="h2 nm">Hi, I'am <span style={{borderRight:`3px solid ${cursorColor}`}}>Abu Faishal</span></p>
                    <p className="text-primary">Web Developer</p>
                    <p id="desc">
                    I am a fresher web developer belongs to Dhanbad, Jharkhand. I have recently completed BCA and currently pursuing MCA and looking for a web developer job.
                    </p>
                    <a href="#" onClick={()=>history.push('/components/ContactForm')} className="btn" id="btnn">Contact Me <img src={send} width="20px" style={{color:"white"}} alt="" title="telegram" /></a>
                </div>
                <div className="d-none d-md-block col-lg-6 col p-2">
                    <div className="imgbox">
                        <img src={mypic} alt="mypic" title="mypic"/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home
